import {
  Avatar,
  Button,
  Card,
  CardContent,
  Grid,
  Hidden,
  Popover,
  Typography,
} from '@material-ui/core';
import { PopoverProps } from '@material-ui/core/Popover';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import moment from 'moment';
import React from 'react';
import { EmployeeDTO } from '../../../../../models/dto/EmployeeDTO';
import { EmployeePunchCardDTO } from '../../../../../models/dto/EmployeePunchCardDTO';
import { convertMinutesToHours } from '../../../../../utils/convertMinutesToHours';

interface EmployeePunchCardDetailsPopover extends PopoverProps {
  employeeRegisters: EmployeePunchCardDTO;
  employeeData: EmployeeDTO | null;
  handleClose: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardContainer: {
      maxWidth: 400,
    },
    closeButton: {
      marginTop: theme.spacing(3),
    },
  }),
);

const EmployeePunchCardDetailsPopover: React.FC<EmployeePunchCardDetailsPopover> = ({
  employeeRegisters,
  employeeData,
  open,
  anchorEl,
  handleClose,
}) => {
  const classes = useStyles();

  return (
    <Popover
      open={open}
      elevation={10}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    >
      <Card className={classes.cardContainer}>
        <CardContent>
          <Grid
            container
            justify="center"
            alignItems="center"
            spacing={1}
            direction="row"
          >
            <Hidden smDown>
              <Grid item md={2}>
                <Avatar />
              </Grid>
            </Hidden>
            <Grid item xs={12} md={10}>
              <Typography
                color="textPrimary"
                style={{
                  fontWeight: 'bolder',
                }}
                variant="subtitle1"
              >
                {employeeData?.nome}
              </Typography>
              <Typography color="textSecondary" variant="body2">
                {employeeData?.cargo?.descricao}
              </Typography>
              <Typography color="textSecondary" variant="body2">
                {employeeData?.escala?.descricaoJornada}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography
                color="textPrimary"
                style={{ fontWeight: 700 }}
                variant="body1"
              >
                Data:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Typography color="textPrimary" variant="body1">
                {moment(employeeRegisters.data).format('dddd - DD/MM/YYYY')}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography
                color="textPrimary"
                style={{ fontWeight: 700 }}
                variant="body1"
              >
                Marcações:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              {employeeRegisters.horarios &&
              employeeRegisters.horarios.length > 0 ? (
                employeeRegisters.horarios.map((horario, index) => {
                  return (
                    <Typography
                      key={index}
                      style={{ display: 'inline' }}
                      color="textPrimary"
                      variant="body1"
                    >
                      {horario}
                      {index < employeeRegisters.horarios.length - 1 && ' - '}
                    </Typography>
                  );
                })
              ) : (
                <Typography color="textPrimary" variant="body1">
                  Sem Marcação
                </Typography>
              )}
            </Grid>

            {employeeRegisters.horasAlmoco > 0 ||
            employeeRegisters.horasAtrasadas > 0 ||
            employeeRegisters.horasExtras50 > 0 ||
            employeeRegisters.horasExtras60 > 0 ||
            employeeRegisters.horasExtras75 > 0 ||
            employeeRegisters.horasExtras80 > 0 ||
            employeeRegisters.horasExtras100 > 0 ||
            employeeRegisters.horasExtras140 > 0 ||
            employeeRegisters.horasExtras200 > 0 ||
            employeeRegisters.horasTrabalhadas > 0 ? (
              <>
                <Grid item xs={12} sm={3}>
                  <Typography
                    color="textPrimary"
                    style={{ fontWeight: 700 }}
                    variant="body1"
                  >
                    Resumo:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={9}>
                  {employeeRegisters.horasTrabalhadas > 0 && (
                    <Typography color="textPrimary" variant="body1">
                      {convertMinutesToHours(
                        employeeRegisters.horasTrabalhadas,
                      )}{' '}
                      trabalhando
                    </Typography>
                  )}
                  {employeeRegisters.horasAlmoco > 0 && (
                    <Typography color="textPrimary" variant="body1">
                      {convertMinutesToHours(employeeRegisters.horasAlmoco)} em
                      almoço
                    </Typography>
                  )}
                  {employeeRegisters.horasAtrasadas > 0 && (
                    <Typography color="textPrimary" variant="body1">
                      {convertMinutesToHours(employeeRegisters.horasAtrasadas)}{' '}
                      em atraso
                    </Typography>
                  )}
                  {employeeRegisters.horasExtras50 > 0 && (
                    <Typography color="textPrimary" variant="body1">
                      {convertMinutesToHours(employeeRegisters.horasExtras50)}{' '}
                      em horas extras 50
                    </Typography>
                  )}
                  {employeeRegisters.horasExtras60 > 0 && (
                    <Typography color="textPrimary" variant="body1">
                      {convertMinutesToHours(employeeRegisters.horasExtras60)}{' '}
                      em horas extras 60
                    </Typography>
                  )}
                  {employeeRegisters.horasExtras75 > 0 && (
                    <Typography color="textPrimary" variant="body1">
                      {convertMinutesToHours(employeeRegisters.horasExtras75)}{' '}
                      em horas extras 75
                    </Typography>
                  )}
                  {employeeRegisters.horasExtras80 > 0 && (
                    <Typography color="textPrimary" variant="body1">
                      {convertMinutesToHours(employeeRegisters.horasExtras80)}{' '}
                      em horas extras 80
                    </Typography>
                  )}
                  {employeeRegisters.horasExtras100 > 0 && (
                    <Typography color="textPrimary" variant="body1">
                      {convertMinutesToHours(employeeRegisters.horasExtras100)}{' '}
                      em horas extras 100
                    </Typography>
                  )}
                  {employeeRegisters.horasExtras140 > 0 && (
                    <Typography color="textPrimary" variant="body1">
                      {convertMinutesToHours(employeeRegisters.horasExtras140)}{' '}
                      em horas extras 140
                    </Typography>
                  )}
                  {employeeRegisters.horasExtras200 > 0 && (
                    <Typography color="textPrimary" variant="body1">
                      {convertMinutesToHours(employeeRegisters.horasExtras200)}{' '}
                      em horas extras 200
                    </Typography>
                  )}
                </Grid>
              </>
            ) : null}

            <Button
              className={classes.closeButton}
              variant="contained"
              onClick={handleClose}
              color="primary"
            >
              Fechar
            </Button>
          </Grid>
        </CardContent>
      </Card>
    </Popover>
  );
};

export default EmployeePunchCardDetailsPopover;
